import { css, useTheme } from '@emotion/react';

const useStyle = () => {
  const theme = useTheme();

  const { background } = theme.palette;
  const { md, sm } = theme.breakpoints;
  const { spacing } = theme;

  const wrapper = css`
    background: white;
    width: 100%;
    position: relative;
    padding: ${spacing(5, '0', 6)};
    margin: 0 auto;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow-x: hidden;

    & > h2 {
      margin-bottom: 15px;

      @media (max-width: ${`${md}px`}) {
        margin: ${spacing('0', 2, 1)};
      }

      @media (max-width: ${`${sm}px`}) {
        text-align: left;
      }
    }

    & > p {
      @media (max-width: ${`${md}px`}) {
        margin: ${spacing('0', 2)};
      }

      @media (max-width: ${`${sm}px`}) {
        text-align: left;
      }
    }

    @media (max-width: ${`${md}px`}) {
      padding: ${spacing(2, '0')};
      min-height: 100vh;
    }
  `;

  const quincyWrapper = css`
    & > h2 {
      font-family: 'Quincy CF';
    }
  `;

  const slideshowWrapper = css`
    width: 100%;
    min-height: 480px;
    margin: ${spacing(4, 'auto')};

    @media (max-width: ${`${md}px`}) {
      margin: ${spacing(3, 'auto', 2)};
    }

    @media (max-width: ${`${sm}px`}) {
      width: 100%;
    }
  `;

  const slideStyle = css`
    min-height: 480px;
    width: 100%;
  `;

  const reelWrapper = css`
    position: relative;
    width: 100%;
    max-width: calc((480px * 9px) / 16px);
    height: 480px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
    overflow: hidden;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;

    & > video {
      width: 100%;
      z-index: 1;
    }
  `;

  const expandedVideoStyle = css`
    & > video {
      width: 100%;
      height: auto;
      z-index: 1;
    }
  `;

  const expandedStyles = css`
    max-width: 490px;
    z-index: 111;
    position: absolute;
    top: 50%;
    transform: translate(-25%, calc(-50% + 50px));
  `;

  const playButton = css`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    background: transparent;
    border: none;
    padding: 0;
    margin: 0;
    left: 50%;
    transform: translate(-50%);

    & > svg {
      color: white;
    }
  `;

  const videoControls = css`
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 100px;
    padding: 20px;
    display: flex;
    justify-content: flex-end;
    gap: ${spacing(1)};
    background: linear-gradient(rgba(0, 0, 0, 0.6), transparent);
    z-index: 1;

    & button {
      background: transparent;
      border: none;
      padding: 0;
      margin: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 20px;
    }
  `;

  const backdrop = css`
    background: ${background.gray};
    width: 100vw;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    pointer-events: none;
  `;

  const ctaWrapper = css`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto;
    gap: ${spacing(1)};
    padding: ${spacing('0', 2)};
    width: 100%;
    max-width: 340px;

    & > a {
      position: inherit;
      max-width: 290px;
    }
  `;

  const slidernationStyle = css`
    display: none;

    @media (max-width: ${`${675}px`}) {
      display: flex;
      justify-content: center;
      margin-bottom: ${spacing(2)};
    }
  `;

  return {
    wrapper,
    quincyWrapper,
    slideshowWrapper,
    slideStyle,
    reelWrapper,
    expandedVideoStyle,
    expandedStyles,
    playButton,
    videoControls,
    backdrop,
    ctaWrapper,
    slidernationStyle,
  };
};

export default useStyle;
